import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, getUtility, Icon } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, Chip, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { billStatuses } from 'src/constants/utilities';
import { AddCorrectionToCurrentBillingCycle } from './AddCorrectionToCurrentBillingCycle';
import { ChargeExportButton } from './ChargeExportButton';
import PreviewStatementsModal from './PreviewStatementsModal';
import useStyles from './styles';
import Utility from './utility';
import { AdditionalChargesAndcredits } from './AdditionalChargesAndcredits';
const Billing = observer(_ref => {
  var _store$homeDashboardS, _property$allocations, _store$homeDashboardS2, _property$dashboard$c, _property$dashboard, _propertiesObj$proper3, _propertiesObj$proper4, _store$homeDashboardS3, _store$homeDashboardS4, _store$homeDashboardS5, _store$homeDashboardS6;
  let propertiesObj = _ref.propertiesObj,
    summary = _ref.summary,
    _ref$defaultExpanded = _ref.defaultExpanded,
    defaultExpanded = _ref$defaultExpanded === void 0 ? false : _ref$defaultExpanded;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const allocatedTotal = summary.allocatedTotal,
    allocationCycleId = summary.allocationCycleId,
    billingCycleSummaries = summary.billingCycleSummaries,
    billsTotal = summary.billsTotal,
    cycleName = summary.cycleName,
    isCurrentAllocationCycle = summary.isCurrentAllocationCycle,
    month = summary.month,
    propertyIdForAllPropertiesMode = summary.propertyId,
    statuses = summary.statuses,
    year = summary.year;
  const isAllPropertiesMode = store.homeDashboardStore.selectedPropertyId === 'all';
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const billingTab = (currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.billingTab) || {};
  const previewQueue = billingTab.previewQueue;
  const property = isAllPropertiesMode ? store.homeDashboardStore.getPropertyById(propertyIdForAllPropertiesMode) || {} : store.homeDashboardStore.getCurrentProperty || {};
  const portfolioId = ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '_';
  const billingCycleIds = ((_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.billingCycleIds.get(allocationCycleId)) || [];
  const propertyId = isAllPropertiesMode ? propertyIdForAllPropertiesMode : property.id;
  const setApplyBill = billingTab.setApplyBill;
  const statusesTexts = billStatuses(t);
  const isLoading = billingTab.allocationCycleIsLoading.get(allocationCycleId + propertyId);
  const _useState = useState(defaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    utilityTables = _useState4[0],
    setUtilityTables = _useState4[1];
  const refresh = async () => {
    if (previewQueue.length === 0 && !store.allocations.getAllocationPreviewAsync.inProgress) {
      let tPs = [];
      for (const id of billingCycleIds) {
        var _property$allocations2, _property$allocations3;
        let tp = _objectSpread({}, (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 ? void 0 : _property$allocations2.billingCycles.get(id)) || {};
        // NOTE: force fetching submetered final states
        if (!!((_property$allocations3 = property.allocations) !== null && _property$allocations3 !== void 0 && _property$allocations3.billingCycles.get(id))) {
          for (const utTable of (_property$allocations4 = property.allocations) === null || _property$allocations4 === void 0 || (_property$allocations4 = _property$allocations4.billingCycles.get(id)) === null || _property$allocations4 === void 0 ? void 0 : _property$allocations4.utilityTables) {
            var _property$allocations4;
            await utTable.fetchSubmeterFinalState({
              billingCycleId: id
            });
          }
        }
        if (tp.utilityTables) {
          var _tp$utilityTables;
          tp.utilityTables = (_tp$utilityTables = tp.utilityTables) === null || _tp$utilityTables === void 0 ? void 0 : _tp$utilityTables.map(tP => _objectSpread(_objectSpread({}, tP), {}, {
            billingCycleId: id,
            isDefaultBillingCycle: tp.isDefaultBillingCycle,
            isHistoricalAllocationCycle: tp.isHistoricalAllocationCycle
          }));
          tPs = [...tPs, ...tp.utilityTables].sort((a, b) => b.isDefaultBillingCycle - a.isDefaultBillingCycle);
        }
      }
      setUtilityTables(tPs);
    }
  };
  useEffect(() => {
    if (billingCycleIds.length > 0) refresh();
  }, [billingCycleIds.length, billingTab.isSubmeterBillModalOpen]);
  useEffect(() => {
    if (previewQueue.length === 0 && !store.allocations.getAllocationPreviewAsync.inProgress) refresh();
  }, [previewQueue]);
  useEffect(() => {
    if (!isOpen || !propertyId) return;
    billingTab.setAllocationCycleIsLoadingById(allocationCycleId + propertyId, true);
    billingCycleSummaries.forEach(s => billingTab.addToPreviewQueue({
      allocationCycleId,
      billingCycleId: s.billingCycleId,
      id: s.billingCycleId + propertyId,
      portfolioId,
      propertyId
    }));
  }, [isOpen, (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.id]);
  useEffect(() => {
    if (billingCycleSummaries.length > 0) {
      var _property$allocations5;
      const ids = [];
      billingCycleSummaries.forEach(s => ids.push(s.billingCycleId));
      (_property$allocations5 = property.allocations) === null || _property$allocations5 === void 0 || _property$allocations5.setBillingCycleIds(allocationCycleId, ids.filter(Boolean));
    }
  }, [billingCycleSummaries.length]);
  const handleAddCustomTable = () => {
    billingTab.setCustomTable({
      allocationCycleId,
      propertyId,
      utilities: utilityTables.map(u => {
        if (!u.isDefaultBillingCycle && !u.isHistoricalAllocationCycle) return null;
        const utilityProviderData = store.utilityProviders.utilities.get(u.utilityId);
        const utilityData = getUtility(utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.utilityTypeName);
        return {
          billingCycleId: u.billingCycleId,
          utilityId: u.utilityId,
          utilityName: utilityData.title
        };
      }).filter(Boolean)
    });
    billingTab.setCustomTableIsOpen(true);
  };
  const handleOpen = () => {
    setIsOpen(!isOpen);
    if (isAllPropertiesMode) setApplyBill(_objectSpread(_objectSpread({}, billingTab.applyBill), {}, {
      allocationCycleId,
      propertyId
    }));
  };
  const handlePreiewCycleCharges = () => {
    var _propertiesObj$proper, _propertiesObj$proper2;
    billingTab.setPreviewCycleCharges({
      allocationCycleId,
      buildingAddress: isAllPropertiesMode ? ((_propertiesObj$proper = propertiesObj[propertyIdForAllPropertiesMode]) === null || _propertiesObj$proper === void 0 || (_propertiesObj$proper = _propertiesObj$proper.propertyInformation) === null || _propertiesObj$proper === void 0 || (_propertiesObj$proper = _propertiesObj$proper.address) === null || _propertiesObj$proper === void 0 ? void 0 : _propertiesObj$proper.addressString) || ((_propertiesObj$proper2 = propertiesObj[propertyIdForAllPropertiesMode]) === null || _propertiesObj$proper2 === void 0 ? void 0 : _propertiesObj$proper2.dashboard.propertyAddress) : null,
      cycleName,
      propertyId
    });
    billingTab.setIsPreviewCycleChargesModalOpen(true);
  };

  // Bulk charge export shows on any convergent, non-AppFolio property, regardless of allocation
  // method: submeter charges flow through AllocationsService.BuildSubmeterCharges into the same
  // per-residency/unit/bill/utility Charge pipeline RUBS uses (LB-5864). The row itself already
  // renders only for cycles whose statements were sent (see below).
  const effectiveConvergent = store.account.featureFlagsStore.getIsConvergentBillingEnabled && !store.company.companyFeatureStore.isAppfolio && ((_property$dashboard$c = (_property$dashboard = property.dashboard) === null || _property$dashboard === void 0 ? void 0 : _property$dashboard.convergentBillingModeOverride) !== null && _property$dashboard$c !== void 0 ? _property$dashboard$c : store.company.companyFeatureStore.convergentBillingMode);
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationItem,
    key: allocationCycleId
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-item",
    onClick: handleOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionHeaderTitle
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
    className: isCurrentAllocationCycle ? '' : classes.disabled
  }, cycleName), isCurrentAllocationCycle ? /*#__PURE__*/React.createElement(React.Fragment, null, statuses.map((status, i) => {
    var _statusesTexts$status, _statusesTexts$status2;
    return /*#__PURE__*/React.createElement(Chip, {
      key: i,
      label: status.count + ' ' + ((_statusesTexts$status = statusesTexts[status.billStatus]) === null || _statusesTexts$status === void 0 ? void 0 : _statusesTexts$status.label),
      variant: (_statusesTexts$status2 = statusesTexts[status.billStatus]) === null || _statusesTexts$status2 === void 0 ? void 0 : _statusesTexts$status2.variant
    });
  })) : /*#__PURE__*/React.createElement(Chip, {
    label: "Sent out",
    variant: "inactive"
  })), isAllPropertiesMode ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", null, ((_propertiesObj$proper3 = propertiesObj[propertyIdForAllPropertiesMode]) === null || _propertiesObj$proper3 === void 0 || (_propertiesObj$proper3 = _propertiesObj$proper3.propertyInformation) === null || _propertiesObj$proper3 === void 0 || (_propertiesObj$proper3 = _propertiesObj$proper3.address) === null || _propertiesObj$proper3 === void 0 ? void 0 : _propertiesObj$proper3.addressString) || ((_propertiesObj$proper4 = propertiesObj[propertyIdForAllPropertiesMode]) === null || _propertiesObj$proper4 === void 0 ? void 0 : _propertiesObj$proper4.dashboard.propertyAddress))) : null), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionHeaderDetails, " accordionArrowWrapper")
  }, summary.isCurrentAllocationCycle && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionHeaderDetailsDayLeft, " ").concat(((_store$homeDashboardS3 = store.homeDashboardStore) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.daysTillStatementDate) < 6 ? 'error' : ((_store$homeDashboardS4 = store.homeDashboardStore) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.daysTillStatementDate) < 16 ? 'warning' : '', " statementWrapper")
  }, /*#__PURE__*/React.createElement("span", {
    class: true
  }, "".concat((_store$homeDashboardS5 = store.homeDashboardStore) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.daysTillStatementDate, " ").concat(t('allocations.days_left'))), /*#__PURE__*/React.createElement(Icon, {
    type: "calendar-clock"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionHeaderDetailsData
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Allocated total:"), /*#__PURE__*/React.createElement("b", null, "$", allocatedTotal.toFixed(2))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Bills total:"), /*#__PURE__*/React.createElement("b", null, "$", billsTotal.toFixed(2)))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionHeaderDetailsIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-down"
  }))))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyList
  }, store.account.featureFlagsStore.allocationCorrectionEnabled && allocationCycleId === ((_store$homeDashboardS6 = store.homeDashboardStore) === null || _store$homeDashboardS6 === void 0 || (_store$homeDashboardS6 = _store$homeDashboardS6.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.currentAllocationCycleId) && /*#__PURE__*/React.createElement(AdditionalChargesAndcredits, {
    allocationCycleId: allocationCycleId,
    propertyId: propertyId
  }), utilityTables.map(utility => {
    var _propertiesObj$proper5, _propertiesObj$proper6;
    return /*#__PURE__*/React.createElement(Utility, {
      allocationCycleId: allocationCycleId,
      billingCycleId: utility.billingCycleId,
      buildingAddress: isAllPropertiesMode ? ((_propertiesObj$proper5 = propertiesObj[propertyIdForAllPropertiesMode]) === null || _propertiesObj$proper5 === void 0 || (_propertiesObj$proper5 = _propertiesObj$proper5.propertyInformation) === null || _propertiesObj$proper5 === void 0 || (_propertiesObj$proper5 = _propertiesObj$proper5.address) === null || _propertiesObj$proper5 === void 0 ? void 0 : _propertiesObj$proper5.addressString) || ((_propertiesObj$proper6 = propertiesObj[propertyIdForAllPropertiesMode]) === null || _propertiesObj$proper6 === void 0 ? void 0 : _propertiesObj$proper6.dashboard.propertyAddress) : null,
      cycleName: cycleName,
      disabled: !isCurrentAllocationCycle,
      key: utility.billingCycleId + utility.utilityId,
      isAdditional: utility.isDefaultBillingCycle && !utility.isHistoricalAllocationCycle,
      isCurrent: isCurrentAllocationCycle,
      property: property,
      propertyId: propertyId,
      utility: utility
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetails
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Allocated total")))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemControl
  }, /*#__PURE__*/React.createElement(Button, {
    'custom-attribute': '697-new-billing-module',
    onClick: handlePreiewCycleCharges,
    size: "medium",
    variant: "actionIcon"
  }, "$", allocatedTotal.toFixed(2)))), isCurrentAllocationCycle ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.accordionBodyItem, " addCustomTable")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoIcon
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleAddCustomTable,
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", null, t('allocations.add_custom_table'))), false ? /*#__PURE__*/React.createElement(AddCorrectionToCurrentBillingCycle, null) : null))) : null, isCurrentAllocationCycle ? null : /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemInfoDetails
  }, /*#__PURE__*/React.createElement("b", null, "Statement ", cycleName))), /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBodyItemControl
  }, effectiveConvergent && /*#__PURE__*/React.createElement(ChargeExportButton, {
    propertyId: propertyId,
    year: year,
    month: month
  }), /*#__PURE__*/React.createElement(PreviewStatementsModal, {
    isCurrentAllocationCycle: isCurrentAllocationCycle,
    month: month,
    name: cycleName,
    propertyId: propertyId,
    year: year
  })))))))));
});
export default Billing;